import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import { useDocumentSEO } from '../utils/useDocumentSEO';

/**
 * /filmagem-foz-do-iguacu
 * LOCAL SEO target: shows, eventos, casamentos, vídeos institucionais em Foz.
 */
const FilmagemFozPage = () => {
  useDocumentSEO({
    title:
      'Filmagem em Foz do Iguaçu | Shows, Eventos, Casamentos | Coutin Agência',
    description:
      'Filmagem profissional em Foz do Iguaçu e região: shows, eventos, casamentos, vídeos institucionais e comerciais. Câmeras Sony 4K, drones DJI FPV e equipe experiente desde 2015. Solicite seu orçamento.',
    canonical: 'https://www.agenciacoutin.com.br/filmagem-foz-do-iguacu',
    ogImage:
      'https://www.agenciacoutin.com.br/images/filmagem-mecanica.jpg',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Filmagem Profissional',
      provider: {
        '@type': 'LocalBusiness',
        name: 'Coutin Agência',
        telephone: '+55-45-98806-8508',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Foz do Iguaçu',
          addressRegion: 'PR',
          addressCountry: 'BR',
        },
      },
      areaServed: [
        { '@type': 'City', name: 'Foz do Iguaçu' },
        { '@type': 'City', name: 'Santa Terezinha de Itaipu' },
        { '@type': 'City', name: 'Medianeira' },
        { '@type': 'City', name: 'Cascavel' },
        { '@type': 'State', name: 'Paraná' },
      ],
      description:
        'Serviço de filmagem profissional para shows, eventos corporativos, casamentos, vídeos institucionais e comerciais em Foz do Iguaçu e região da Tríplice Fronteira.',
      url: 'https://www.agenciacoutin.com.br/filmagem-foz-do-iguacu',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5.0',
        reviewCount: '8',
        bestRating: '5',
      },
    },
  });

  return (
    <ServiceLandingPage
      gaSource="page-filmagem-foz"
      showLocalProof={true}
      overline="Filmagem Profissional em Foz do Iguaçu"
      h1="A melhor filmagem de Foz do Iguaçu para shows, eventos e marcas."
      highlightWord="filmagem de Foz do Iguaçu"
      subtitle="Somos uma agência de filmagem em Foz do Iguaçu especializada em produções que carregam emoção e qualidade cinematográfica. De shows lotados a vídeos institucionais e casamentos inesquecíveis — nossa equipe entrega vídeo que sua marca, evento ou momento merece."
      whatsappMessage="Olá! Vim pela página de filmagem em Foz do Iguaçu e gostaria de um orçamento. Tipo de projeto (show, evento, casamento, institucional, comercial):"
      heroImage="/images/filmagem-mecanica.jpg"
      benefits={[
        { value: '10+', label: 'Anos em Foz do Iguaçu' },
        { value: '4K', label: 'Resolução Cinema' },
        { value: 'FPV', label: 'Drones DJI Avata' },
        { value: '5,0★', label: 'Avaliação Google' },
      ]}
      intro={[
        'Encontrar uma equipe de filmagem em Foz do Iguaçu que entregue qualidade cinematográfica, prazo respeitado e preço justo nem sempre é fácil. A Coutin Agência nasceu em 2015 exatamente para preencher esse espaço — somos uma agência audiovisual que trata cada projeto como obra única, do briefing à entrega final.',
        'Atendemos toda Foz do Iguaçu e a região da Tríplice Fronteira (Santa Terezinha de Itaipu, Medianeira, São Miguel do Iguaçu, Cascavel e Ciudad del Este). Quando necessário, viajamos para projetos especiais em todo o Paraná e estados vizinhos.',
        'Trabalhamos com câmeras Sony 4K, drones DJI Avata FPV indoor e outdoor, gimbals profissionais, microfones lapela e captação multi-câmera. Mas mais importante do que o equipamento é a direção criativa — pensamos cada plano, cada movimento e cada corte para gerar a emoção certa no espectador.',
      ]}
      blocks={[
        {
          h2: 'Tipos de filmagem que fazemos em Foz do Iguaçu',
          subtitle:
            'Cada projeto é diferente. Trabalhamos por diária ou por projeto fechado — sempre com orçamento personalizado de acordo com o porte e a complexidade do trabalho.',
          list: [
            'Filmagem de shows e festivais ao vivo',
            'Cobertura de eventos corporativos e congressos',
            'Filmagem de casamentos e cerimônias',
            'Vídeos institucionais para empresas',
            'Comerciais e ads para redes sociais',
            'Tours imobiliários com drone FPV',
            'Aftermovies de eventos e festivais',
            'Cobertura de inaugurações e ativações de marca',
          ],
        },
        {
          h2: 'Por que escolher a Coutin para filmar em Foz do Iguaçu',
          paragraphs: [
            'Há mais de 10 anos somos referência em filmagem em Foz do Iguaçu. Atendemos empresas locais que cresceram com a gente — e isso reflete na nossa nota máxima no Google (5,0 estrelas). Quando você contrata a Coutin, contrata uma equipe que está na cidade, conhece os melhores locais, sabe lidar com as exigências de cada tipo de evento e entrega no prazo combinado.',
            'Diferente de produtoras que viajam de longe e somem depois do contrato, nossa estrutura é local. Reuniões presenciais em Foz, suporte rápido pelo WhatsApp e visitas técnicas antes do projeto fazem toda a diferença para garantir um resultado impecável.',
          ],
        },
        {
          h2: 'Como funciona o processo',
          subtitle:
            'Da primeira conversa à entrega do material, você acompanha cada etapa com clareza.',
          list: [
            'Briefing estratégico (presencial ou online)',
            'Roteiro e cronograma de gravação aprovados antes do dia',
            'Equipe completa com captação multi-câmera + áudio profissional',
            'Edição cinematográfica com color grading premium',
            'Revisões inclusas conforme o pacote contratado',
            'Entrega em alta resolução para apresentação e cortes para redes sociais',
          ],
        },
      ]}
    />
  );
};

export default FilmagemFozPage;
